let $component = {};

/**
 * @function useInject
 * @description
 * Vue3부터는 Vue인스턴스 접근을 SFC로 제한 되었다. Ex) @deprecated prototype
 * 그러므로 일반 모듈에서 공통 컴포넌트를 사용하기 위해 해당 컴포저블을 이용한다.
 * @param component Provider에서 정의한 공통 컴포넌트와 동일
 */
export const useInject = function (component) {
    if (typeof component != 'undefined' && _isEmpty()) {
        $component = new Proxy(component, {
            get: function (obj, prop) {
                return this.has(obj, prop) ? Reflect.get(obj, prop).value ?? Reflect.get(obj, prop) : undefined;
            },
            has (obj, prop) {
                return obj.hasOwnProperty(prop) ? Reflect.has(obj, prop) : false;
            },
        });
    }
}


export const useComponent = function () {
    if (_isEmpty()) {
        return undefined;
    }
    return $component;
}


function _isEmpty () {
    return Object.keys($component ?? {}).length == 0;
}